import axios from '../axios'

const patchCancelEventApi = async (eventId, cancelReason) => {
    return await axios.patch(`api/teacher/events/${eventId}/cancel`, { cancelReason })
}

export default patchCancelEventApi
